<script lang="ts">
  // Shared by MessageBubble.svelte and CommentItem.svelte -- the grouped reaction-pill row and
  // its derived grouping/"did I react with this emoji" computation were byte-identical in both.
  export let reactions: { user_id: number; emoji: string }[];
  export let currentUserId: number;
  export let onReact: (emoji: string) => void;

  $: groups = Object.entries(
    reactions.reduce<Record<string, number>>((acc, r) => {
      acc[r.emoji] = (acc[r.emoji] ?? 0) + 1;
      return acc;
    }, {})
  );
  $: mine = new Set(reactions.filter((r) => r.user_id === currentUserId).map((r) => r.emoji));
</script>

{#if groups.length > 0}
  <div class="flex flex-wrap gap-1">
    {#each groups as [emoji, count]}
      <button
        type="button"
        class="flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-xs {mine.has(emoji) ? 'border-primary bg-primary/10' : 'border-border bg-muted/60'}"
        on:click={() => onReact(emoji)}
      >
        <span>{emoji}</span>
        {#if count > 1}<span class="text-muted-foreground">{count}</span>{/if}
      </button>
    {/each}
  </div>
{/if}
